import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getShipmentParcelLockerCode } from '../../actions/shipmentsActions';

const useLockerCode = (shipmentId: string) => {
	const dispatch = useDispatch<any>();
	const { lockerCode } = useSelector(({ shipmentsReducer }) => shipmentsReducer);

	useEffect(() => {
		if (!lockerCode[shipmentId]) dispatch(getShipmentParcelLockerCode(shipmentId));
	}, [lockerCode, shipmentId, dispatch]);

	return {
		lockerCode,
	};
};

export default useLockerCode;
